import React from 'react'
import { Toaster } from 'react-hot-toast'

import biplan from '../../images/biplan.svg'

import s from './Preloader.module.css'

const Preloader = ({ message }: { message: string }) => {
  return (
    <div className={s.preloder}>
      <p className={s.preloder__text}>
        {message}
      </p>
      
      <div className={s.preloder__airplane}>
        <div className={s.preloder__line + ' ' + s.line}></div>
        <div className={s.preloder__img}>
          <img
            src={biplan}
            // lazy="loading"
            alt="biplan"
            width="86"
            height="135"
          />
        </div>
      </div>
    </div>
  )
}

export default Preloader
